export const Antd_PrefixCls = 'ant-oms' // antd prefixCls属性，防止样式冲突
// antd 全局主题变量
export const Antd_Global_Theme = {
	token: {
		borderRadiusLG: 2,
		borderRadius: 6,
		borderRadiusSM: 2,
	},
}
